import React, { useState, useEffect } from "react"
import axios from "axios"
import { Badge, Card, CardBody, Container, Row } from "reactstrap"
import moment from "moment"
import { useDispatch } from "react-redux"
import L1Report from "./LeaveAuthority/L1Report"
import L2Report from "./LeaveAuthority/L2Report"
import AttendanceTabs from "./LeaveAuthority/Tab"
const LeaveReport = () => {
  const [loading, setLoading] = useState(false)
  const [isSubmit, setSubmit] = useState(false)

  const dispatch = useDispatch()
  const [leaveStatus, setLeaveStatus] = useState("Pending")

  const [track, setTrack] = useState()
  const [report1, setReport1] = useState()
  const [report2, setReport2] = useState()
  const token = JSON.parse(localStorage.getItem("Token"))
  const acad_id = localStorage.getItem("acad_id");
  
  const getLeaveTitle = async () => {
    setLoading(true)
    try {
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/leave/get-leave-auth-report",
        data: {
          acadId: acad_id,
        },
        headers: {
          Authorization: token,
        },
      }).then(res => {
        const report1Data = res.data.leaveAuthReport1
        const report2Data = res.data.leaveAuthReport2

        if (report1Data.length > 0) {
          setTrack("Approved L1")
        } else if (report2Data.length > 0) {
          setTrack("Approved L2")
        }
        setReport1(report1Data)
        setReport2(report2Data)

        setLoading(false)
      })
    } catch (error) {
      console.error("Error fetching leave data:", error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isSubmit || (leaveStatus && acad_id)) {
      getLeaveTitle()
    }
  }, [leaveStatus, acad_id, isSubmit])

  return (
    <Row className="mt-5 py-4">
      <div className="container-fluid">
        <Container>
          <Card>
            <CardBody className="p-2">
              <h1 className="text-center fs-4">Leave Authority</h1>
              <AttendanceTabs activeTab={track} setActiveTab={setTrack} />
              {track ? (
                <L1Report
                  report1={report1}
                  track={track}
                  setLoading={setLoading}
                  setSubmit={setSubmit}
                />
              ) : (
                <L2Report
                  report2={report2}
                  track={track}
                  setLoading={setLoading}
                  setSubmit={setSubmit}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </Row>
  )
}

export default LeaveReport
